import React from "react";

import Articles_Banner from "../images/banner_images/laptop/articles.png"
import trend_cardimage_1 from "../images/Insights/trend_cardimage_1.png"
import trend_cardimage_2 from "../images/Insights/trend_cardimage_2.png"
import trend_cardimage_3 from "../images/Insights/trend_cardimage_3.png"




function Articles () {


    const trendCard =[
        {
            src:trend_cardimage_1,
            date:"june 15,2023",
            heading:"Lorem ipsum dolor sit amet consectetur. Tortor varius duis volutpat arcu a facilisi mauris feugiat elit.",
            content:"Lorem ipsum dolor sit amet consectetur. Tortor varius duis volutpat arcu a facilisi mauris feugiat elit. Lorem ipsum dolor sit amet consectetur. Tortor varius duis volutpat arcu a facilisi mauris feugiat elit.",
        },
        {
            src:trend_cardimage_2,
            date:"june 15,2023",
            heading:"Coimbatore Development Map",
            content:"Lorem ipsum dolor sit amet consectetur. Tortor varius duis volutpat arcu a facilisi mauris feugiat elit. Lorem ipsum dolor sit amet consectetur. Tortor varius duis volutpat arcu a facilisi mauris feugiat elit.",
        },
        {
            src:trend_cardimage_3,
            date:"june 15,2023",
            heading:"Lorem ipsum dolor sit amet consectetur. Tortor varius duis volutpat arcu.",
            content:"Lorem ipsum dolor sit amet consectetur. Tortor varius duis volutpat arcu a facilisi mauris feugiat elit. Lorem ipsum dolor sit amet consectetur.",
        },
    ]


    return(
    <>
        <img className="w-full h-[450px] object-cover" src={Articles_Banner} alt="Article Banner" />

        <div className="max-w-6xl mx-auto my-24 px-4 flex flex-wrap justify-around font-[lato]">
            
            <div className="max-w-[600px]">
                <h1 className="text-[52px] font-[400] leading-[58px] tracking-[1px] my-6">Summary</h1>
                <p className="text-[20px] text-font-grey leading-[34px] ">
                    Lorem ipsum dolor sit amet consectetur. Id tellus diam morbi tellus vitae nunc at nunc commodo. Sed dignissim a semper scelerisque. Lacinia morbi et sed aliquam parturient a donec nisi vitae. Amet etiam eu diam id at vel velit. Vel enim venenatis quis ultrices nunc. Et dui eget quis integer id. Bibendum ut nunc in velit tellus adipiscing vitae gravida. Adipiscing pellentesque at arcu in pellentesque fames aenean.
                    Amet quis est ullamcorper scelerisque arcu eget tincidunt a proin. Varius sapien turpis enim mauris nisl imperdiet egestas id. Turpis ac egestas turpis tempus malesuada mauris massa proin. Est nisi gravida ac amet diam. 
                </p>
                <p className="text-[20px] text-font-grey leading-[34px]  mt-8">
                    Odio enim ac odio et ante sit duis. Aliquam odio nisl neque fringilla. Dolor aliquam porta parturient luctus consequat. Libero fames faucibus tincidunt pellentesque amet lectus mauris maecenas. Vestibulum in nibh pellentesque quam egestas sed viverra amet. Sit eget placerat pulvinar volutpat ut sem magna ut. At facilisis vitae aliquam eu. Penatibus porta velit dignissim at etiam malesuada. At praesent convallis vestibulum vitae lectus. 
                    Hendrerit amet faucibus nunc euismod pretium. Placerat nisi congue augue sed.
                </p>
            </div>

            <div className="max-w-[400px] h-[212px] mx-auto bg-card-grey text-center px-12 mt-28">
                <h2 className="text-[24px] font-[600] mt-12 mb-6">Download this Report</h2>
            </div>

        </div>

        <div className="bg-brown text-white font-[lato] px-6 py-4 sm:py-12">

            <div className="max-w-[820px] mx-auto my-10 text-center ">
                <h2 className="milestone-heading py-8">Looking for more insights? <br className="hidden md:block" />Never miss an update.</h2>
                <p className="text-[#C8C4C4] text-[22px] font-[400] leading-[29.8px] mb-6">The latest news, insights and opportunities from global commercial real estate markets straight to your inbox.</p>
            </div>
            

        </div>

        {/* Trend */}

        <div className="max-w-[1323px] mx-auto px-6 my-24">
            <h1 className="font-[merriweather] text-[44px] text-center lg:text-left lg:text-[52px]">Trend</h1>

            <div className="flex justify-center flex-wrap my-4 lg:justify-between">
                {
                trendCard.map((items) => {
                    return(
                        <div className="font-[lato] w-[399px] h-[500px] relative mt-10">
                            <img src={items.src} alt="cardimage"/>
                            <p className="text-font-grey text-[12px] uppercase py-2">{items.date}</p>
                            <h2 className="text-[20px] font-medium leading-[24px] py-1">{items.heading}</h2>
                            <p className="text-font-grey text-[14px] leading-[21px] mt-2 py-2">{items.content}</p>
                            <div className="lg:absolute bottom-0">
                                <button className="bg-yellow text-[10.5px] uppercase tracking-[1px] mt-4 py-2 px-4 ">view more</button>
                            </div>
                        </div> 
                    );
                })}
            </div> 
        </div>




    </>
    );
}

export default Articles ;